export const IconPasswordKey: {
  name: 'icon_password_key-0af3c785cd62'
} = {
  name: 'icon_password_key-0af3c785cd62'
}
